/** @jsx jsx */

import { Dropdown, Grid, Surface, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    padding: 15px;
  `,
};

type Props = {
  onChangePeriod: (value) => void;
  periodToShow: string;
};

const dropdownItems = [
  { label: 'last hour', value: '1h' },
  { label: 'last 12 hours', value: '12h' },
  { label: 'last day', value: '1d' },
  { label: 'last week', value: '1w' },
];

function Period({ onChangePeriod, periodToShow }: Props) {
  return (
    <Surface borderColor="GrayWarm4">
      <div css={Styles.root} data-testid="Period">
        <Grid columns={1} gap={10}>
          <Text tag="h3" type="Body4">
            Period
          </Text>
          <Text tag="p">
            Choose the period of time to view events in the chart.
          </Text>
          <Dropdown
            getLabelForItem={item => item.label}
            items={dropdownItems}
            onChange={onChangePeriod}
            selectedItem={
              dropdownItems.find(({ value }) => value === periodToShow) ||
              dropdownItems[0]
            }
            size="medium"
          />
        </Grid>
      </div>
    </Surface>
  );
}

export default Period;
